function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-282.29 -45.439)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 282.29 45.433)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m41.174 0.021851h-27.391c-7.5892 0-13.783 6.1935-13.783 13.783v27.434c0 7.5456 6.1935 13.739 13.783 13.739h27.435c7.5892 0 13.783-6.1935 13.783-13.783v-27.391c-0.0436-7.5892-6.2371-13.783-13.826-13.783zm-22.855 44.488h-7.8509v-22.68h7.8509zm-3.9691-26.17c-2.2244 0-4.0127-1.7882-4.0127-4.0126 0-2.2245 1.7883-4.0127 4.0127-4.0127s4.0127 1.7882 4.0127 4.0127c-0.0436 2.2244-1.8319 4.0126-4.0127 4.0126zm30.182 26.17h-6.586v-10.991c0-2.6606-0.349-6.0627-3.9691-6.0627-3.7074 0-4.318 2.8787-4.318 5.8882v11.166h-6.5424v-22.68h6.1062v3.0532h0.1745c0.9596-1.7447 3.184-3.0968 6.6733-3.0968 7.1966 0 8.4615 4.1436 8.4615 10.293z",
  fill: "#22323f"
})));

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.552mm",
    height: "14.541mm",
    viewBox: "0 0 14.552 14.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f67b509e.svg";
export { ForwardRef as ReactComponent };